import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Seo from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      if (u.role === "admin") nav("/admin");
      else if (u.role === "business") nav("/business");
      else nav("/dashboard");
    } catch (e2) {
      setErr(e2.message);
    } finally { setBusy(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Seo title="Sign In" description="Sign in to your ADN Local FanFest account to view your Fan Passport, check-ins, offers, and prizes." noindex />
      <div className="text-xs tracking-[0.3em] uppercase text-primary">Welcome Back</div>
      <h1 className="font-bebas text-5xl mt-2">SIGN IN</h1>
      <form onSubmit={submit} className="mt-6 adn-card p-6 space-y-4" data-testid="login-form">
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/60">Email</span>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required
            data-testid="login-email"
            autoComplete="email"
            inputMode="email"
            name="email"
            aria-label="Email address"
            className="mt-1 block w-full bg-[#0b1428] border border-adn-border rounded px-3 py-3 focus:border-primary outline-none text-sm"/>
        </label>
        <label className="block">
          <span className="text-xs uppercase tracking-widest text-white/60">Password</span>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required
            data-testid="login-password"
            autoComplete="current-password"
            name="password"
            aria-label="Password"
            className="mt-1 block w-full bg-[#0b1428] border border-adn-border rounded px-3 py-3 focus:border-primary outline-none text-sm"/>
        </label>
        {err && <div className="text-destructive text-sm" data-testid="login-error">{err}</div>}
        <button type="submit" disabled={busy}
          data-testid="login-submit"
          className="w-full px-6 py-4 bg-primary text-black font-bebas text-2xl rounded-sm hover:brightness-110 disabled:opacity-60 min-h-[56px]">
          {busy ? "SIGNING IN…" : "SIGN IN"}
        </button>
        <div className="flex items-center justify-between text-xs">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="text-primary underline">
            Forgot password?
          </Link>
          <span className="text-white/60">
            No account? <Link to="/register" className="text-primary underline">Register</Link>
          </span>
        </div>
      </form>
    </div>
  );
}
